/* tslint:disable */
//----------------------
// <auto-generated>
//     Generated using the Tocsoft.GraphQLCodeGen toolchain https://github.com/tocsoft/GraphQLCodeGen
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import {HttpClient} from 'aurelia-fetch-client';
import {inject} from 'aurelia-framework';
import { apiUrl } from '../../constants'

interface fetchClient {
    fetch(url: RequestInfo, init: RequestInit): Promise<Response>
}

class GraphQLResponse
{
    data: any
    errors: Array<{ message: string }>
}

function CreateCollectionEntityError(message:string, httpResponse:Response, graphqlResponse?: GraphQLResponse) {
    this.name = 'CreateCollectionEntityError';
    this.message = message || 'Error fetching graphql response';
    this.stack = (new Error()).stack;
    this.httpResponse = httpResponse;
    if(graphqlResponse && graphqlResponse.errors){
        this.errors = graphqlResponse.errors.map(x=>x.message);
    }
  }
  CreateCollectionEntityError.prototype = Object.create(Error.prototype);
  CreateCollectionEntityError.prototype.constructor = CreateCollectionEntityError;
  
export { CreateCollectionEntityError }

@inject(HttpClient, apiUrl)
export class CreateCollectionEntityClient {

    constructor(public client: fetchClient, public url: string) { }
	
	createCollectionEntity_createCollectionEntity(	update? :CreateCollectionEntityRequestInput) : Promise<CreateCollectionEntityCreateCollectionEntityResult>{
        return this.client.fetch(this.url, {
            method : 'POST',
            body : JSON.stringify({
                query : `mutation createCollectionEntity($update: CreateCollectionEntityRequestInput) {
  createCollectionEntity(request: $update) {
    success
    id
    isLocked
  }
}
`,
                variables : {
					update : update ,
                }
            })
        }).then(response=>{
            if(response.status != 200){
                // error result
                throw new CreateCollectionEntityError("http error running 'createCollectionEntity_createCollectionEntity', see httpResponse for more details.", response)
            }else{
                return response.json().then((json:GraphQLResponse)=>{
                    
                    if(json.errors && json.errors.length > 0){
                        throw new CreateCollectionEntityError("graphql error(s) running 'createCollectionEntity_createCollectionEntity', see errors collection fro more details", response, json)
                    }

                    const result: any = CreateCollectionEntityCreateCollectionEntityResult.fromJS(json.data);                
                    
                    return result;
                })
            }
        })
    }	
}

export class CreateCollectionEntityRequestInput {
		fieldName? :string;
		id? :string;
		jsonEntity? :string;
		ownerId? :string;

    static fromJS(json:any):CreateCollectionEntityRequestInput{
        if(json == null || json == undefined){
            return null;
        }
        
        var result = new CreateCollectionEntityRequestInput();

	result.fieldName = json["fieldName"];
	result.id = json["id"];
	result.jsonEntity = json["jsonEntity"];
	result.ownerId = json["ownerId"];

        return result;
    }
}

export class CreateCollectionEntityCreateCollectionEntityResult {
		createCollectionEntity? :CreateCollectionEntityResultResult;

    static fromJS(json:any):CreateCollectionEntityCreateCollectionEntityResult{
        if(json == null || json == undefined){
            return null;
        }
        
        var result = new CreateCollectionEntityCreateCollectionEntityResult();

result.createCollectionEntity= CreateCollectionEntityResultResult.fromJS(json["createCollectionEntity"]);

        return result;
    }
}

export class CreateCollectionEntityResultResult {
		success :boolean;
		id? :string;
		isLocked :boolean;

    static fromJS(json:any):CreateCollectionEntityResultResult{
        if(json == null || json == undefined){
            return null;
        }
        
        var result = new CreateCollectionEntityResultResult();

	result.success = json["success"];
	result.id = json["id"];
	result.isLocked = json["isLocked"];

        return result;
    }
}


